export default __webpack_public_path__ + "static/fb-24322bc2bea43079daf27c7b6a8c664d.png";